import { errorToast } from "@/v2-ui/toast"
import Selector from "@/v2-backoffice-client/components/selector"
import type { SelectorItemProps } from "@/v2-backoffice-client/components/selector"
import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"
import { useCustomerTenantAssignMutation } from "@/v2-backoffice-client/customer/tenant/add/customer.tenant.assign.mutation"

export type CustomerTenantAddSelectorItemProps = Omit<
  SelectorItemProps,
  "value" | "children"
> & {
  tenant: TenantFragment
  externalCustomerId: string
}

function CustomerTenantAddSelectorItem(
  props: CustomerTenantAddSelectorItemProps,
) {
  const { tenant, externalCustomerId, onSelect, ...selectorItemProps } = props

  const [select, { loading, error }] = useCustomerTenantAssignMutation()
  errorToast(error, {
    title: "Failed to assign team",
  })

  const value = String(tenant.Id)

  return (
    <Selector.Item
      key={tenant.Id}
      isLoading={loading}
      value={value}
      onSelect={() => {
        select({
          variables: { tenantId: tenant.Id, externalCustomerId },
        })
        onSelect?.(value)
      }}
      {...selectorItemProps}
    >
      <Selector.ItemText
        isRemoved={tenant.IsDeleted}
        primary={tenant.Name}
        secondary={tenant.CustomerName}
      />
    </Selector.Item>
  )
}

export default CustomerTenantAddSelectorItem
